import React, { ImgHTMLAttributes, MutableRefObject } from 'react';
import { useIntl } from 'react-intl';
import { cn } from '../../helpers';
import styles from './image.module.scss';

interface IImage extends ImgHTMLAttributes<HTMLImageElement> {
    key?: string;
    title?: string;
    selectable?: boolean;
    onClick?: () => void;
    internalRef?: MutableRefObject<HTMLImageElement>;
}

export const Image = ({ internalRef, className, selectable, title, id, alt, role, ...props }: IImage): JSX.Element => {
    const { formatMessage } = useIntl();

    const imageClasses = cn(className, {
        [styles.imageButton]: role === 'button',
        [styles.disableForceTouch]: !selectable,
    });

    return (
        <img
            {...props}
            id={id}
            role={role}
            ref={internalRef}
            className={imageClasses}
            {...(title && { title })}
            alt={formatMessage({ id: alt || 'IMAGE_ICON' })}
        />
    );
};
